import { useQuery } from "@tanstack/react-query";
import { fetchWithAuth } from "@/lib/api/client";

export interface UsageByKind {
  kind: string;
  calls: number;
  input_tokens: number;
  output_tokens: number;
  cache_read_tokens: number;
  cache_write_tokens: number;
}

/** Resumen de consumo de IA por tipo (solo admin). */
export function useUsage() {
  return useQuery<UsageByKind[], Error>({
    queryKey: ["usage"],
    queryFn: () => fetchWithAuth("/api/v1/usage"),
    refetchOnWindowFocus: true,
  });
}
